import { Injectable } from '@angular/core';
import { MfaApiConnect } from './MfaApi.connect';

export interface MfaResponse {
    workflowId: string; // "00000000-0000-0000-0000-000000000000"
}

export interface MfaRequest {
    isMfaEnabled: boolean;
}

@Injectable({ providedIn: 'root' })
export class MfaApiService {
    constructor(private api: MfaApiConnect) {}

    async setMfaStateByCompanyGuid(
        companyGuid: string,
        isMfaEnabled: boolean
    ): Promise<MfaResponse> {
        return this.api.setMfaStateByCompanyGuid(companyGuid, isMfaEnabled);
    }
}
